
export default function AboutHero() {
  return (
    <section className="relative min-h-screen flex items-center pt-[72px] overflow-hidden">
      {/* Background Image - 亮色调 AI+SaaS 风格，与其他页面配色一致 */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/5f0214af083cdacb3b0f12eefcd2958d.jpg"
          alt="background"
          className="w-full h-full object-cover object-top"
        />
        {/* 统一双层遮罩结构 */}
        <div className="absolute inset-0 bg-gradient-to-br from-white/65 via-white/40 to-teal-50/50"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-white/80 via-white/40 to-transparent"></div>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 py-20 w-full">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            {/* 统一顶部标签徽章样式 */}
            <div className="inline-flex items-center gap-2 bg-teal-50 border border-teal-200 rounded-full px-4 py-2">
              <i className="ri-building-4-line text-teal-700"></i>
              <span className="text-sm font-medium text-teal-700">关于星贸云 · AI驱动合规管理</span>
            </div>

            {/* 统一主标题样式 */}
            <h1 className="text-5xl lg:text-6xl font-extrabold leading-tight">
              <span className="bg-gradient-to-r from-[#0D9488] to-[#14B8A6] bg-clip-text text-transparent drop-shadow-sm">
                AI驱动的
              </span>
              <br />
              <span className="text-gray-800">
                出口合规管理平台
              </span>
            </h1>

            {/* 统一正文样式 */}
            <div className="space-y-3">
              <p className="text-lg text-gray-700 leading-relaxed">
                以结构化数据引擎与规则系统为核心，
              </p>
              <p className="text-lg text-gray-500 leading-relaxed">
                构建可解释、可追溯、可复盘的出口业务管理体系。
              </p>
            </div>

            {/* 核心数据亮点 */}
            <div className="grid grid-cols-3 gap-4 pt-2">
              {[
                { value: '3+', label: '业务形态覆盖', icon: 'ri-global-line' },
                { value: '99%', label: '合规通过率', icon: 'ri-shield-check-line' },
                { value: '10x', label: '效率提升', icon: 'ri-speed-up-line' },
              ].map((stat) => (
                <div key={stat.label} className="bg-white/80 backdrop-blur-sm border border-teal-100 rounded-2xl p-4 text-center shadow-sm">
                  <div className="w-8 h-8 flex items-center justify-center mx-auto mb-2">
                    <i className={`${stat.icon} text-xl text-teal-500`}></i>
                  </div>
                  <div className="text-2xl font-extrabold bg-gradient-to-r from-[#0D9488] to-[#14B8A6] bg-clip-text text-transparent">
                    {stat.value}
                  </div>
                  <div className="text-xs text-gray-500 mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>

            {/* 统一按钮组样式 */}
            <div className="space-y-3 max-w-md pt-2">
              <button
                onClick={() => window.REACT_APP_NAVIGATE('/capabilities')}
                className="w-full h-14 bg-gradient-to-r from-[#FF6B35] to-[#FF8C42] text-white font-medium rounded-full hover:scale-105 transition-transform flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer shadow-lg"
              >
                查看产品及价格
                <i className="ri-arrow-right-line"></i>
              </button>
              <button
                onClick={() => window.REACT_APP_NAVIGATE('/scenarios')}
                className="w-full h-14 bg-white/70 backdrop-blur-sm border-2 border-[#14B8A6] text-[#0D9488] font-medium rounded-full hover:bg-[#14B8A6] hover:text-white transition-all whitespace-nowrap cursor-pointer"
              >
                查看场景方案
              </button>
            </div>

            {/* 统一底部说明 */}
            <div className="pt-6 border-t border-gray-200">
              <p className="text-xs text-gray-500 flex items-start gap-2">
                <span className="w-1 h-4 bg-[#FF6B35] rounded-full flex-shrink-0 mt-0.5"></span>
                <span className="leading-relaxed">
                  <strong className="text-gray-600">产品定位：</strong>专为出口企业设计，覆盖跨境电商、外贸公司、市场商户三大业务形态。
                </span>
              </p>
            </div>
          </div>

          {/* Right Visual - 品牌价值卡片 */}
          <div className="relative flex flex-col gap-5 justify-center">
            {[
              {
                icon: 'ri-brain-line',
                color: 'from-teal-500 to-cyan-500',
                bg: 'bg-teal-50',
                border: 'border-teal-200',
                text: 'text-teal-700',
                title: 'AI智能引擎',
                desc: '规则自动校验，异常智能识别，减少人工干预',
              },
              {
                icon: 'ri-links-line',
                color: 'from-orange-400 to-amber-400',
                bg: 'bg-orange-50',
                border: 'border-orange-200',
                text: 'text-orange-700',
                title: '全链路追溯',
                desc: '从申报到核销，每一步操作留痕可查可复盘',
              },
              {
                icon: 'ri-shield-star-line',
                color: 'from-emerald-500 to-green-500',
                bg: 'bg-emerald-50',
                border: 'border-emerald-200',
                text: 'text-emerald-700',
                title: '合规安全保障',
                desc: '对接海关直连通道，证据链完整归档备查',
              },
            ].map((card, index) => (
              <div
                key={card.title}
                className={`relative rounded-2xl border-2 p-5 backdrop-blur-sm transition-all duration-300 ${
                  index === 0
                    ? `${card.bg} ${card.border} shadow-xl scale-[1.03]`
                    : 'bg-white/80 border-gray-200 shadow-sm hover:shadow-md hover:scale-[1.02]'
                }`}
              >
                <div className="flex items-center gap-4">
                  <div className={`w-14 h-14 flex items-center justify-center rounded-xl bg-gradient-to-br ${card.color} shadow-md flex-shrink-0`}>
                    <i className={`${card.icon} text-2xl text-white`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className={`text-lg font-bold mb-1 ${index === 0 ? card.text : 'text-gray-800'}`}>
                      {card.title}
                    </div>
                    <p className={`text-sm ${index === 0 ? card.text : 'text-gray-500'}`}>
                      {card.desc}
                    </p>
                  </div>
                </div>
              </div>
            ))}
            <p className="text-center text-xs text-gray-400 mt-1">核心产品价值</p>
          </div>
        </div>
      </div>
    </section>
  );
}
